import { useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import { API_URL } from '../../../../utils/constants';
import createIcon from '../../../../static/img/createIcon.svg';
import GridWrapper from '~/src/components/common/GridWrapper';

export default function MarginsList(): JSX.Element {
  const history = useHistory();
  const url = `${API_URL}/margins/get-all`;
  const onRowClick = (rowInfo) => {
    history.push(`/margins/edit/${rowInfo.dataItem.id}`);
  };
  const StatefullGrid = withState(Grid, url, { onRowClick });

  const countryCell = (p) => {
    return <td>{p?.dataItem?.country?.name}</td>;
  };

  return (
    <WhitePad>
      <TitleComponent
        title="Margins"
        titleRight="Create"
        onRightHandler={(): void => history.push('/margins/create')}
        iconRight={createIcon}
        titleLeft="Back"
        onLeftHandler={(): void => history.goBack()}
      />
      <GridWrapper>
        <StatefullGrid>
          <GridColumn field="countryId" title="Country" cell={countryCell} />
          <GridColumn field="marginWholesaler" title="Margin Wholesaler" />
          <GridColumn field="marginDistributor" title="Margin Distributor" />
          <GridColumn field="marginRetailer" title="Margin Retailer" />
          <GridColumn field="vat" title="VAT" />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
